var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './KodanshaArrow.scss';
// import SvgArrow from './SvgArrow';
import { ReactComponent as SvgArrow } from '../../Assets/icons/buttonArrow.svg';
var KodanshaArrow = function (_a) {
    var onClick = _a.onClick, _b = _a.active, active = _b === void 0 ? true : _b, text = _a.text, _c = _a.withArrow, withArrow = _c === void 0 ? true : _c, _d = _a.styles, styles = _d === void 0 ? '' : _d, _e = _a.ignoreActive, ignoreActive = _e === void 0 ? false : _e, bold = _a.bold, _f = _a.invert, invert = _f === void 0 ? false : _f, title = _a.title;
    var onButtonClicked = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (active && onClick || ignoreActive) {
            onClick.apply(void 0, __spreadArray([], __read(args), false));
        }
    };
    function getClassName() {
        var className = styles;
        if (!active) {
            className += " disabled";
        }
        if (invert) {
            className += " invert";
        }
        return className;
    }
    return (_jsxs("div", { role: 'button', onClick: onButtonClicked, className: "arrow-container ".concat(getClassName()), "aria-label": text, title: title, children: [_jsx("span", { className: "arrow-btn ".concat(withArrow ? 'with-arrow' : 'no-arrow', " text-bold ").concat(bold && 'text-bold'), children: text }), withArrow && _jsx("div", { className: 'icon-wrapper', children: _jsx(SvgArrow, { fill: active ? 'white' : '#757575', width: 80, className: 'icon' }) })] }));
};
export default KodanshaArrow;
